import FadeInImage from 'components/FadeInImage';
import { useVerifyIsMobile } from 'hooks/useVerifyIsMobile';
import React from 'react';
import { useSelector } from 'react-redux';
import './style.scss';

export const AppLoader = () => {
  const { isMobile } = useVerifyIsMobile(768);
  const {
    Onboarding2_Imagen_PantallaCarga_1 = '',
    Onboarding2_Imagen_PantallaCarga_2 = '',
  } = useSelector(state => state.asset);

  return (
    <div className="AppLoaderV2">
        <FadeInImage 
            imageAlt="app-loader"
            imageSrc={isMobile
                ? Onboarding2_Imagen_PantallaCarga_2
                : Onboarding2_Imagen_PantallaCarga_1}
                classNames={["AppLoaderV2__Img"]}
                width={"100vw"}
                height="100vh"
        />
      {/* <img
        className="AppLoaderV2__Img"
        src={
          isMobile
            ? Onboarding2_Imagen_PantallaCarga_2
            : Onboarding2_Imagen_PantallaCarga_1
        }
        alt="loader"
      /> */}
    </div>
  );
};
